<section class="header">
  <edge-global-header></edge-global-header>
</section>

<section class="hero">
  <edge-global-hero
    image="/assets/images/football/football-hero.jpg"
    logo="/assets/images/football/edge-football-logo.svg"
    [socialIcons]="socialIcons"
    [tagline]="tagline">
    <a angulartics2On="click"
       angularticsCategory="Outbound Clicks"
       angularticsEvent="Launch App Button"
       [angularticsProperties]="{ label: 'Football Onelink' }"
       target="_blank"
       href="http://onelink.to/edgefootball"
       class="button yellow">Launch App</a>
  </edge-global-hero>
</section>

<section class="content">
  <edge-football-content></edge-football-content>
</section>

<section class="app-downloads">
  <edge-global-app-downloads
    sport="Football"
    sportLinkApple="//itunes.apple.com/us/app/goarmy-edge-football/id968154309"
    sportLinkGoogle="//play.google.com/store/apps/details?id=sed.ags.USArmySports.football"
    sportLinkWindows="//www.microsoft.com/en-us/store/p/goarmy-edge-football/9nblggh5xd4p">
  </edge-global-app-downloads>
</section>

<section class="testamonials">
  <edge-global-testamonials [testimonial]="testimonial" [author]="author"></edge-global-testamonials>
</section>

<section class="bottom">
  <edge-global-bottom></edge-global-bottom>
</section>

<section class="footer">
  <edge-global-footer></edge-global-footer>
</section>
